module.exports = __webpack_public_path__ + "img/brandme_ia_primary.4aacb14a.svg";